export default "__VITE_ASSET__DSNoq751__"